module.exports = __webpack_public_path__ + "static/media/yellowsappdp.f273a87b.jpg";